import type {
  BudgetData,
  BudgetStatusData,
  BudgetTrendData,
  CategoryBudgetItem,
  ExpenseCategory,
  MonthComparisonData,
  ProjectionsData,
} from "@boo/shared";
import { request } from "./apiClient";

export async function fetchBudget(
  year: number,
  month: number,
): Promise<BudgetData | null> {
  // API answers 200 with an empty body when no budget is set
  return (await request<BudgetData>(`/budget/${year}/${month}`)) || null;
}

export async function fetchBudgetStatus(
  year: number,
  month: number,
): Promise<BudgetStatusData | null> {
  // API answers 200 with an empty body when no budget is set
  return (
    (await request<BudgetStatusData>(`/budget/${year}/${month}/status`)) || null
  );
}

export async function fetchBudgetProjections(
  year: number,
  month: number,
): Promise<ProjectionsData> {
  return request<ProjectionsData>(`/budget/${year}/${month}/projections`);
}

export async function fetchBudgetTrend(
  months: number,
  category?: ExpenseCategory,
): Promise<BudgetTrendData> {
  const params = new URLSearchParams({ months: String(months) });
  if (category) params.set("category", category);
  return request<BudgetTrendData>(`/budget/trend?${params.toString()}`);
}

export async function fetchBudgetComparison(
  year: number,
  month: number,
): Promise<MonthComparisonData> {
  return request<MonthComparisonData>(`/budget/${year}/${month}/comparison`);
}

export async function saveBudget(
  year: number,
  month: number,
  overallAmount: number,
  categoryBudgets?: CategoryBudgetItem[],
): Promise<BudgetData> {
  return request<BudgetData>(`/budget/${year}/${month}`, {
    method: "PUT",
    data: { overallAmount, categoryBudgets },
  });
}
